var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header", [
        _c("div", { staticClass: "headertitle" }, [
          _vm._v("Prize Designs for Modern Furniture+Lighting"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "headeryear" }, [_vm._v("AWARD")]),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 6, lg: 4 } }, [
            _vm.$auth.user()
              ? _c(
                  "div",
                  { staticClass: "side-menu-frame" },
                  [
                    _c("router-link", { attrs: { to: _vm.accountLink } }, [
                      _vm._v("Account"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "furniture-lighting-form" } } },
                      [_vm._v("New Submission")]
                    ),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: _vm.submissionLink } }, [
                      _vm._v("My Submissions"),
                    ]),
                  ],
                  1
                )
              : _c("div", [_vm._v("\n                 \n            ")]),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 18, lg: 12 } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer", [
        _c("div", { staticClass: "footerlogo-caption" }, [
          _vm._v(
            "\n            Prize Designs for Modern Furniture + Lighting® is a registered trademark\n            of Metropolitan Arts Press Ltd. copyright © 2022 all rights reserved.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/images/furniture_lighting_award_logo.svg" },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }